import { mdiDelete, mdiFile, mdiFileExcelBox, mdiFilePdfBox, mdiFileWordBox, mdiImage } from "@mdi/js";
import Icon from "@mdi/react";
import type { File } from "easy-db-node";
import { ReactNode, useState } from "react";
import Modal from "react-responsive-modal";

type HeaderProps = {
    background: "papers" | "writer" | "pens" | "mountain" | "numbers" | "stars",
    title: string,
    children?: React.ReactNode,
};

export function Header({ background, title, children }: HeaderProps) {
    return <header className={background}>
        <div className="background">
            <div className="content">
                <div className="title">{title}</div>
                <div className="bottom">
                    {children}
                </div>
            </div>
        </div>
    </header>
}

export function Separator({ line }: { line?: boolean }) {
    return (
        <div className={`separator ${line ? "line" : ""}`}>
            {!line && <>
                <span className="cir c-1" />
                <span className="cir c-2" />
                <span className="cir c-3" />
            </>}
        </div>
    );
}

export function Loading() {
    return <div className="flex-center">
        <div className="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>;
}

export function Remove({ onRemove, children }: { children?: ReactNode, onRemove: () => void }) {
    const [remove, setRemove] = useState(false);
    return (
        <>
            <button className={`remove ${children ? "" : "icon"}`} onClick={() => setRemove(true)}>
                <Icon path={mdiDelete} size={1} /> {children}
            </button>
            <Modal center open={remove} onClose={() => setRemove(false)}>
                <h3>Opravdu smazat tuto položku?</h3>
                <div className="buttons">
                    <button
                        className="danger"
                        onClick={() => {
                            setRemove(false);
                            onRemove();
                        }}
                    >
                        Ano
                    </button>
                    <button onClick={() => setRemove(false)}>Ne</button>
                </div>
            </Modal>
        </>
    );
}


// ----------- Layout ----------
export function ContentSplit({ left, right }: { left: React.ReactNode, right: React.ReactNode }) {
    return <div className="content-split">
        <div className="left">
            <div className="content">
                <section>
                    <div className="page">
                        {left}
                    </div>
                </section>
            </div>
        </div>
        <div className="right">
            <div className="content">
                <section>
                    <div className="page">
                        {right}
                    </div>
                </section>
            </div>
        </div>
    </div>;
}

export function FileIcon({ download }: { download: { file: File } }) {
    const url = download.file.url;

    let path = mdiFile;
    if (url.endsWith(".pdf")) path = mdiFilePdfBox;
    if (url.endsWith(".jpg") || url.endsWith(".jpeg") || url.endsWith(".png")) path = mdiImage;
    if (url.endsWith(".doc") || url.endsWith(".docx")) path = mdiFileWordBox;

    if (url.endsWith(".xls") || url.endsWith(".xlsx")
        || url.endsWith(".csv") || url.endsWith(".tsv")) path = mdiFileExcelBox;

    return <Icon path={path} size={1} />;
}